<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells_hd">基础信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <date-field slot="ec_date" :label="customLabel.ec_date || '点检日期'" v-model="form.main.ec_date" />
        <div class="weui-cell" slot="eq_code">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_code || "设备编号"}}</label>
          </div>
          <div class="weui-cell__bd">
            <span>{{ form.main.eq_code }}</span>
          </div>
        </div>
        <equipment-field slot="eq_name"
          :label="customLabel.eq_name || '设备名称'"
          v-model="form.main.eq_name"
          @select="onSelectEquipment"
        />
        <div class="weui-cell" slot="eq_orispeccode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_orispeccode || "规格型号"}}</label>
          </div>
          <div class="weui-cell__bd">
            <span>{{ form.main.eq_orispeccode }}</span>
          </div>
        </div>
        <div class="weui-cell" slot="eq_brand">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_brand || "品牌"}}</label>
          </div>
          <div class="weui-cell__bd">
            <span>{{ form.main.eq_brand }}</span>
          </div>
        </div>
        <div class="weui-cell" slot="eq_kind">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_kind || "设备类别"}}</label>
          </div>
          <div class="weui-cell__bd">
            <span>{{ form.main.eq_kind }}</span>
          </div>
        </div>
        <div class="weui-cell" slot="eq_check_time">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_check_time || "检查周期"}}</label>
          </div>
          <div class="weui-cell__bd flex">
            <span>{{ form.main.eq_check_time }}</span>
            <span v-if="form.main.eq_check_period == 'year'">年</span>
            <span v-if="form.main.eq_check_period == 'month'">月</span>
            <span v-if="form.main.eq_check_period == 'week'">周</span>
            <span v-if="form.main.eq_check_period == 'day'">日</span>
          </div>
        </div>
        <div class="weui-cell" slot="eq_state">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.eq_state || "设备状态"}}</label>
          </div>
          <div class="weui-cell__bd">
            <span>{{ form.main.eq_state }}</span>
          </div>
        </div>
        <div class="weui-cell" slot="ec_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ec_remark || "备注"}}</label>
          </div>
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              placeholder="请输入内容"
              rows="3"
              v-model="form.main.ec_remark"
              maxlength="300"
            ></textarea>
            <div class="weui-textarea-counter">
              <span>{{
                form.main.ec_remark ? form.main.ec_remark.length : 0
              }}</span
              >/300
            </div>
          </div>
        </div>
        <file-field v-model="form.main.eq_attach" slot="eq_attach"/>
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="'1-' + xindex"
      >
        <div class="weui-cells__title">
          <span>检查信息{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem1(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
           <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-cell" slot="ecd_project">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.ecd_project || "检查项目"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.ecd_project"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="ecd_method">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.ecd_method || "检查方法"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.ecd_method"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="ecd_standard">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.ecd_standard || "检查标准"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.ecd_standard"
                placeholder="请填写"
              />
            </div>
          </div>
          <combo-search-box slot="ecd_result"
            :label="customLabel.ecd_result || '结果'" 
            placeholder="请选择或输入结果"
            v-model="item.ecd_result"
            url="/api/oa/equipmentCheckResult/getCombo"
            ref="combo1"
          />
          <file-field v-model="item.ecd_attach" :label="customLabel.ecd_attach || '故障图片'" />
          <div class="weui-cell" slot="ecd_describe">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.ecd_describe || "故障描述"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.ecd_describe"
                placeholder="请填写"
              />
            </div>
          </div>
           </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem1"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >保存</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import EquipmentField from "@/components/field/EquipmentField.vue";
import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileField,
    EquipmentField,
    ComboSearchBox,
    DateField,
  },
  data() {
    return {
      baseUrl: "/api/oa/equipmentCheck",
      codeField: "ec_code",
      statusField: "ec_audit_status",
      caller: "EquipmentCheck",
      xtype: "oa-equipmentcheck-formpanel",
      form: {
        main: {
          ec_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
        },
        items: [
          {
            ecd_project: null,
            ecd_method: null,
            ecd_standard: null,
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  methods: {
    getData() {
      var me = this,
        form = me.$route.params.form;
      if (form) {
        var list = me.$route.params.form.items,
          main = me.$route.params.form.main;
        me.form.main.eq_code = main.eq_code;
        me.form.main.eq_name = main.eq_name;
        me.form.main.ec_eqid = main.id;
        me.form.main.eq_orispeccode = main.eq_orispeccode;
        me.form.main.eq_brand = main.eq_brand;
        me.form.main.eq_kind = main.eq_kind;
        me.form.main.eq_check_period = main.eq_check_period;
        me.form.main.eq_check_time = main.eq_check_time;
        me.form.main.eq_state = main.eq_state;
        me.form.items = [];
        list.forEach((item) => {
          me.form.items.push({
            ecd_project: item.ed_project,
            ecd_method: item.ed_method,
            ecd_standard: item.ed_standard,
            ecd_detno: item.ed_detno,
            ecd_eqid: item.ed_eqid,
          });
        });
      }
    },
    onSelectEquipment(selection) {
      var me = this,
        main = me.form.main;
      main.eq_code = selection.eq_code;
      main.ec_eqid = selection.eq_id;
      main.eq_orispeccode = selection.eq_orispeccode;
      main.eq_brand = selection.eq_brand;
      main.eq_kind = selection.eq_kind;
      main.eq_check_period = selection.eq_check_period;
      main.eq_check_time = selection.eq_check_time;
      main.eq_state = selection.eq_state;
      me.form.items = [];
      selection.detailList.forEach((item) => {
        me.form.items.push({
          ecd_project: item.ed_project,
          ecd_method: item.ed_method,
          ecd_standard: item.ed_standard,
        });
      });
    },
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items;
      if (!main.eq_name) {
        me.$weui.topTips("请选择设备名称", 2000);
      } else {
        var count1 = 0;
        items.forEach(function (item) {
          if (!item.ecd_project) {
            me.$weui.topTips(`第${count1 + 1}行未填写检查项目`, 2000);
            return false;
          } else if (!item.ecd_method) {
            me.$weui.topTips(`第${count1 + 1}行未填写检查方法`, 2000);
            return false;
          } else if (!item.ecd_standard) {
            me.$weui.topTips(`第${count1 + 1}行未填写检查标准`, 2000);
            return false;
          } else if (!item.ecd_result) {
            me.$weui.topTips(`第${count1 + 1}行未填写结果`, 2000);
            return false;
          } else {
            count1++;
            item.ecd_detno = count1;
          }
        });
        if (count1 == items.length) {
          items.forEach((item, index) => {
            me.result_combo_save(item.ecd_result, index);
          });
          me.p_save();
        }
      }
    },
    result_combo_save(eq_result, key) {
      var me = this;
      let combo1 = me.$refs.combo1[key].data,
        save = combo1.some((item) => {
          return item.value == eq_result;
        });
      if (!save) {
        me.$ajax({
          url: "/api/oa/equipmentCheckResult/save",
          method: "POST",
          jsonData: {
            ecr_name: eq_result,
            id: 0,
          },
        }).then();
      }
    },
    /**
     * 删除行
     */
    removeItem1(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem1() {
      var me = this,
        items = me.form.items;
      items.push({
        ecd_project: null,
        ecd_method: null,
        ecd_standard: null,
      });
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.time {
  flex: 1;
}
.unit {
  width: 50px;
}
</style>